import React from "react";
import { GradeStripHeader } from "./styles";
import { IconButton, Tab, Tabs } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { colors } from "theme";
import useUser from "hooks/useUser";

function GradeStrip({ activeGrade, setActiveGrade, grades, editGrade }) {
  const { getRole } = useUser();
  const role = getRole();

  return (
    <GradeStripHeader>
      <Tabs
        value={activeGrade}
        onChange={(_, newValue) => setActiveGrade(newValue)}
        TabIndicatorProps={{
          style: {
            background: colors.primaryColor,
          },
        }}
        sx={{
          marginBottom: "-2px !important",
        }}
      >
        {grades.map((_, index) => (
          <Tab
            sx={{
              fontSize: "14px !important",
              textTransform: "none",
              fontWeight: "500 !important",
              fontFamily: "Inter !important",
              border: "none !important",
              marginRight: "14px !important",
              color: "#4a4a4a !important",
              "&.Mui-selected": {
                color: "#231A3D !important",
                marginRight: "14px !important",
                border: "none !important",
              },
            }}
            label={`Grade ${index + 1}`}
            key={index}
            value={index}
          />
        ))}
      </Tabs>
      {role === "admin" && (
        <IconButton onClick={editGrade}>
          <EditIcon />
        </IconButton>
      )}
    </GradeStripHeader>
  );
}

export default GradeStrip;
